<template>
  <section class="home-block">
    <!-- <div ref="particle" class="particle d-none d-md-block" /> -->
    <div class="content">
      <div class="container">
        <div ref="title" class="title">
          <slot name="title">
            <h2>Места поблизости</h2>
          </slot>
        </div>
        <SlidesScroll v-if="mq.lgPlus && preparedItems.length > 0">
          <GalleryItem
            v-for="item in preparedItems"
            :key="item.title"
            :item="item"
            :from="'Parks'"
            :class="{ mobileActive: item.mobileActive }"
          />
        </SlidesScroll>
        <div v-if="!mq.lgPlus" class="list">
          <swiper
            class="hasPagination"
            navigation
            :preload-images="false"
            :slides-per-view="'auto'"
            :space-between="24"
          >
            <swiper-slide v-for="item in preparedItems" :key="item.title">
              <GalleryItem
                :item="item"
                :from="'Parks'"
                :class="{ mobileActive: item.mobileActive }"
              />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SlidesScroll from "@/components/SlidesScroll.vue";
import GalleryItem from "@/components/GalleryItem.vue";
import SwiperCore, { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper.min.css";
SwiperCore.use([Navigation, Pagination]);
import { gsap } from "gsap";
import { is_touch } from "@/helpers.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollToPlugin);
export default {
  components: {
    SlidesScroll,
    GalleryItem,
    Swiper,
    SwiperSlide,
  },
  inject: ["mq", "mainStore"],
  data() {
    return {};
  },
  computed: {
    items() {
      return this.mainStore.state.data?.location_near_project?.slides ?? [];
    },
    preparedItems() {
      return this.items.map((item) => {
        return {
          img: [{ src: item.image?.source }],
          title: item?.name,
          text: item?.addition_text,
          mobileActive: true,
        };
      });
    },
  },
  mounted() {
    if (!is_touch()) {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: this.$el,
            start: "top top",
            end: "bottom center",
            scrub: true,
            ease: "none",
          },
        })
        .to(
          this.$refs.particle,
          {
            autoAlpha: 0,
          },
          0
        );
    }
    ScrollTrigger.matchMedia({
      "(max-width: 767px)": () => {
        const items = gsap.utils.toArray(this.$el.querySelectorAll(".item"));
        items.forEach((item, index) => {
          ScrollTrigger.create({
            trigger: item,
            start: "top 65%",
            end: "bottom top",
            invalidateOnRefresh: true,
            onEnter: (self) => {
              this.preparedItems[index].mobileActive = true;
              gsap.fromTo(
                item.querySelector(".item__image"),
                { autoAlpha: 0 },
                { autoAlpha: 1 }
              );
              this.$nextTick(() => {
                ScrollTrigger.refresh();
              });
            },
            onLeaveBack: (self) => {
              this.preparedItems[index].mobileActive = false;
              gsap.fromTo(
                item.querySelector(".item__image"),
                { autoAlpha: 1 },
                { autoAlpha: 0 }
              );
              this.$nextTick(() => {
                ScrollTrigger.refresh();
              });
            },
          });
        });

        // gsap.to(wrap, {
        // 	x: () => -(wrap.scrollWidth - pin.clientWidth),
        // 	ease: 'none',
        // 	snap: 'x',
        // 	scrollTrigger: {
        // 		trigger: pin,
        // 		start: 'center center',
        // 		end: () => '+=' + wrap.scrollWidth / 2,
        // 		pin: pin,
        // 		invalidateOnRefresh: true,
        // 		scrub: 0.5,
        // 		//markers: true,
        // 		//fastScrollEnd: fastScrollEnd,
        // 		//preventOverlaps: preventOverlaps,
        // 		// onUpdate: (e) => {
        // 		// 	console.log(e.progress);
        // 		// },
        // 	},
        // });
      },
    });
  },
  // methods: {
  //   itemControl(item) {
  // 		this.items.forEach((el) => {
  // 			if (el.title == item[0]) {
  // 				el.mobileActive = true;
  //         gsap.to(window, { scrollTo: {y: item[1], offsetY: 90}, duration: 0.5, ease: 'power2.inOut' });
  // 			} else {
  // 				el.mobileActive = false;
  // 			}
  // 		});
  //   }
  // }
};
</script>

<style scoped>
.particle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 1474px;
  height: 1217px;
  margin-left: -737px;
  background: url(~@i/bg-parks.svg) 0 0 no-repeat;
  background-size: contain;
}

.list .swiper-container {
  overflow: inherit;
}

.title {
  margin-bottom: 80px;
  text-align: center;
}

.content {
  position: relative;
}

:deep(.item) {
  cursor: pointer;
}

:deep(.item__content) {
  position: absolute;
  z-index: 10;
  padding: 34px;
  pointer-events: none;
}

:deep(.item__title) {
  color: #e0e0e0;
}

@media (max-width: 991px) {
  .list :deep(.swiper-slide) {
    width: 450px;
  }

  .list :deep(.swiper-button-prev),
  .list :deep(.swiper-button-next) {
    display: none;
  }

  :deep(.swiper-slide.swiper-slide-active) {
    margin-right: 12px !important;
  }
}

@media (max-width: 767px) {
  .item {
    margin: 0 0 15px;
    padding: 0 0 15px;
    border-bottom: 1px solid #e5e5e5;
  }

  .item:last-child {
    margin: 0;
    border-bottom: 0;
  }

  .item :deep(.item__subtitle) {
    margin-top: 5px;
    margin-bottom: -4px;
    font-size: 14px;
    transition: all 0.15s;
  }

  .item :deep(.item__title) {
    transition: all 0.15s;
  }

  .item:not(.mobileActive) :deep(.item__content) {
    position: relative;
    margin: 0;
  }

  .item:not(.mobileActive) :deep(.item__image),
  .item:not(.mobileActive) :deep(.item__text) {
    overflow: hidden;
    height: 0;
    margin: 0;
    padding: 0;
  }

  .item:not(.mobileActive) :deep(.item__title) {
    font-size: 24px;
  }

  .item:not(.mobileActive) :deep(.item__subtitle) {
    margin-top: 2px;
    margin-bottom: 0;
    font-weight: 300;
    font-size: 14px;
  }

  .item:not(.mobileActive) :deep(.item__thumb) {
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    width: 44px;
    height: 44px;
  }

  .item:not(.mobileActive) :deep(.item__thumb img) {
    position: absolute;
    top: 1px;
    left: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .title {
    margin-bottom: 24px;
  }

  h2 {
    font-size: 36px;
  }

  .list :deep(.swiper-slide) {
    width: 375px;
  }
}

@media (max-width: 575px) {
  /* :deep(.swiper-wrapper) {
    align-items: flex-end;
  } */

  .item :deep(.item__text) {
    margin-top: 15px;
    padding-bottom: 15px;
    font-size: 14px;
  }

  .item:last-child :deep(.item__text) {
    padding-bottom: 0;
  }

  :deep(.item__title) {
    min-height: 70px;
  }

  .list :deep(.swiper-slide) {
    width: 300px;
  }

  :deep(.item__content) {
    padding: 15px;
  }
}

@media (max-width: 374px) {
  .list :deep(.swiper-slide) {
    width: 290px;
  }
}

.swiper-slide :deep(a.active) {
  background: #291f1f99;
}

:deep(a.active) {
  background: #291f1f99;
}
</style>
